module.exports = __webpack_public_path__ + "img/tracesecurity-logo.88b43305.png";